/* eslint-disable no-nested-ternary */
export const completeBox = (markButton) => ({
    cursor: 'pointer',
    border: `1.5px solid ${markButton ? '#00A76F' : '#ddd'}`,
    color: markButton ? '#00A76F' : '#637381',
    borderRadius: '20px',
    padding: '4px 14px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    transition: 'all 0.2s ease',
    bgcolor: markButton ? 'rgba(0, 167, 111, 0.08)' : 'transparent',
    '&:hover': {
        borderColor: '#00A76F',
        bgcolor: 'rgba(0, 167, 111, 0.06)'
    }
});

export const completeTypo = (markButton, isLight) => ({
    fontSize: '13px !important',
    fontWeight: 600,
    color: `${markButton ? '#00A76F' : isLight ? '#637381' : '#fff'}`,
    marginLeft: '6px'
});

export const methodMAinBox = (reminderError) => ({
    mb: 2.5,
    mt: 1,
    cursor: 'pointer',
    border: reminderError ? '1px solid red' : 'transparent',
    borderRadius: reminderError ? '10px' : 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    '@media(max-width: 500px)': {
        flexWrap: 'wrap'
    }
});

export const leadAutoComplete = {
    marginBottom: 2,
    '.MuiAutocomplete-input': {
        pl: '0px !important'
    },
    '.MuiAutocomplete-endAdornment': {
        display: 'none'
    }
};
export const searchIconStyle = (isLight) => ({
    color: isLight ? 'black' : '#637381',
    width: 20,
    height: 20,
    ml: '5px'
});

export const taskGroupStyle = {
    mx: 1,
    my: 0.5,
    borderRadius: 0.75,
    typography: 'body2',
    textTransform: 'capitalize',
};
export const addReminderHeaderBoxStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: '16px 24px',
    borderBottom: '1px solid #f0f0f0'
};